import React from 'react';
import { PricingAPI } from '../../../controller/PricingAPI';
import { hasPermission } from '../../../navigation';
import TodoComplianceDrawer from './TodoPage/components/TodoComplianceDrawer';
import TodoRoutinePane from './TodoPage/components/TodoRoutinePane';

// 例行工作的「管理」- 誰要定期做什麼。個人的「我今天要做什麼」在待辦頁。
//
// 元件刻意留在 TodoPage/components/ 而不搬過來：它們共用 TodoPage/todoHelpers.js
// (recurrenceLabel、formatStartTime、complianceStateMeta、showRequestError)，
// 搬檔會讓那幾條 import 變成跨頁面的相對路徑，換不到任何東西。
function RoutinePage() {
    const isAdmin = hasPermission(PricingAPI.auth.getPermissions(), '*');
    const [compliance, setCompliance] = React.useState(false);

    return (
        <div>
            <TodoRoutinePane canManage={isAdmin} onCompliance={() => setCompliance(true)} />
            {/* 條件渲染而不是只靠 open：元件不卸載的話，預設區間的 moment() 只會在
                第一次掛載時算一次 - 分頁開著過夜，隔天打開看到的結束日還是昨天 */}
            {compliance && (
                <TodoComplianceDrawer
                    open={compliance}
                    canFilterDepartment={isAdmin}
                    onClose={() => setCompliance(false)}
                />
            )}
        </div>
    );
}

export default RoutinePage;
